import { Component, OnDestroy, ChangeDetectionStrategy, computed, input, output } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-social-chat-feed',
  templateUrl: './social-chat-feed.component.html',
  styleUrls: ['./social-chat-feed.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialChatFeedComponent implements OnDestroy {
  public readonly moderatedChat = input(false);
  public readonly hostChatSetting = input(false);
  public readonly chatModerationSetting = input(false);
  public readonly isUserHost = input(false);

  public readonly moderatedChatSignal = computed(() => this.moderatedChat());
  private readonly tabSelectedSignal = computed(() => this.tabSelected());
  public readonly tabSelected = input<string | undefined>(undefined);

  public readonly selectedChat = output<string>();

  private destroyed$ = new ReplaySubject<boolean>(1);

  protected readonly isHostFeed = computed(() => this.tabSelectedSignal() === 'Hosts');
  protected readonly isModerationFeed = computed(() => this.tabSelectedSignal() === 'Moderation Log');

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
